






































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import RequiredMarkComponent from "@/components/common/parts/RequiredMarkComponent.vue";
import FormBoxComponent from "@/components/common/form/FormBoxComponent.vue";
import FormRowComponent from "@/components/common/form/FormRowComponent.vue";
import InputTextComponent from "@/components/common/parts/InputTextComponent.vue";
import CalendarComponent from "@/components/common/parts/CalendarComponent.vue";
import SelectComponent from "@/components/common/parts/SelectComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import CategoryIconSelectComponent from "@/components/pages/sensors/CategoryIconSelectComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import TimepickerComponent from "@/components/packages/timepicker/TimepickerComponent.vue";
import RadioComponent from "@/components/common/parts/RadioComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { getEquipmentIcon } from "@/typescript/lib/common/get_equipment_icon";
import { getRoutePath } from "@/router/routes";
import { getMeasureTargetEquipments } from "@/typescript/api_client/emesh_api/stores/measure_target_equipments_api";
import { fillZero } from "@/typescript/lib/common/fill_zero";
import {
  getEquipmentsApi,
  postEquipmentsApi
} from "@/typescript/api_client/emesh_api/equipments/equipments_api";
import {
  GetEquipmentsResponse,
  PostEquipmentsErrorResponse
} from "@/typescript/api_client/emesh_api/equipments/types";
import { Moment } from "@/typescript/lib/common/moment";
import { GetMeasureTargetEquipmentsResponse } from "../../typescript/api_client/emesh_api/stores/types";
import { DisplayTime } from "@/typescript/packages/timepicker/types";
export {
  GetEquipmentsResponse,
  PostEquipmentsErrorResponse,
  Moment,
  GetMeasureTargetEquipmentsResponse,
  DisplayTime
};

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    RequiredMarkComponent,
    FormBoxComponent,
    FormRowComponent,
    InputTextComponent,
    CalendarComponent,
    SelectComponent,
    ButtonComponent,
    CategoryIconSelectComponent,
    ConfirmDialogComponent,
    TimepickerComponent,
    RadioComponent,
    FooterComponent
  }
})
export default class SensorsEditPage extends Vue {
  sensorNo: string = "";
  sensorName: { [s: string]: any } = { value: "", errors: [] };
  equipmentkindId: { [s: string]: any } = { value: "", errors: [] };
  sensorId: { [s: string]: any } = { value: "", errors: [] };
  sensorKind: { [s: string]: any } = { value: "", errors: [] };
  modelName: { [s: string]: any } = { value: "", errors: [] };
  serialNo: { [s: string]: any } = { value: "", errors: [] };
  installationDatetime: { [s: string]: any } = { value: "", errors: [] };
  removalDatetime: { [s: string]: any } = { value: "", errors: [] };
  measureTargetSerialNo: { [s: string]: any } = { value: "", errors: [] };
  measureTargetEquipmentKindName: { [s: string]: any } = {
    value: "",
    errors: []
  };
  measureTargetEquipmentKindId: { [s: string]: any } = {
    value: "",
    errors: []
  };
  thresholdFrom: { [s: string]: any } = { value: "", errors: [] };
  thresholdTo: { [s: string]: any } = { value: "", errors: [] };
  gaurdTime: { [s: string]: any } = { value: "", errors: [] };
  snoozeTime: { [s: string]: any } = { value: "", errors: [] };
  selectedDayTimeFrom: { [s: string]: any } = { value: "", errors: [] };
  selectedDayTimeTo: { [s: string]: any } = { value: "", errors: [] };
  defTimes: { [s: string]: any }[] = [];
  defTimeStart: DisplayTime = { HH: "00", mm: "00" };
  defTimeEnd: DisplayTime = { HH: "00", mm: "00" };
  isDefTimeError: boolean = false;
  timeConstant: { [s: string]: any } = { value: "", errors: [] };
  dispFlg: number = 0;
  categories = Object.keys(getEquipmentIcon(0, "all")).map(value => {
    return {
      id: value,
      icon: getEquipmentIcon(0, "all")[value]["on"]
    };
  });
  iconKind: { [s: string]: any } = { value: "", errors: [] };
  hasError: boolean = false;
  errorMessages: { [s: string]: string } = {
    range_input: "入力の範囲が違います",
    range_error: "範囲が違います",
    required_input: "入力してください",
    character_error: "半角数値を入力してください"
  };
  isCategoriesVisible: boolean = false;
  measureTargetEquipments: GetMeasureTargetEquipmentsResponse[] = [];
  selectedMeasureTargetEquipmentId: string = "";
  isConfirmDialogOpen: boolean = false;
  timepickerWidth: string = "78px";

  closeCategory() {
    this.isCategoriesVisible = false;
  }
  toggle(isVisible) {
    this.isCategoriesVisible = isVisible;
  }

  setCategory(category) {
    this.iconKind.value = category.id;
  }

  setSensorNameInput(value: string) {
    this.sensorName.value = value;
  }

  setInstallationDatetime(value: string) {
    this.installationDatetime.value = new Moment(
      "YYYY/MM/DD",
      value
    ).getFormatDate();
  }

  setRemovalDatetime(value: string) {
    this.removalDatetime.value = new Moment(
      "YYYY/MM/DD",
      value
    ).getFormatDate();
  }

  setThresholdFrom(value: string) {
    this.thresholdFrom.value = value;
  }

  setThresholdTo(value: string) {
    this.thresholdTo.value = value;
  }

  setGaurdTime(value: string) {
    this.gaurdTime.value = value;
  }

  setSnoozeTime(value: string) {
    this.snoozeTime.value = value;
  }

  setDefTimeStart(value: DisplayTime) {
    this.defTimeStart = value;
  }

  setDefTimeEnd(value: DisplayTime) {
    this.defTimeEnd = value;
  }

  addDefTime(timeStart: DisplayTime, timeEnd: DisplayTime) {
    const addTime = {
      start: `${timeStart.HH}:${timeStart.mm}`,
      end: `${timeEnd.HH}:${timeEnd.mm}`
    };

    if (addTime.start >= addTime.end) return;

    if (
      this.defTimes.some(time => {
        // 重複があればtrue
        if (time.start == addTime.start && time.end == addTime.end) return true;
      })
    )
      return;

    const sortTimes: any[] = [...this.defTimes];
    sortTimes.push(addTime);
    sortTimes.sort(function(a, b) {
      if (a.start > b.start) {
        return 1;
      } else {
        return -1;
      }
    });

    // 開始時刻 < １つ前の終了時刻のチェック
    for (let i = 1; i < sortTimes.length; i++) {
      if (sortTimes[i].start < sortTimes[i - 1].end) return;
    }

    this.defTimes = [...sortTimes];
  }

  deleteDefTime(index) {
    this.defTimes.splice(index, 1);
  }

  setTimeConstant(value: string) {
    this.timeConstant.value = value;
  }

  setDispFlg(value: number) {
    this.dispFlg = value;
  }

  submit() {
    this.resetError();
    this.validateForm();
    if (this.hasError) return;
    this.save();
  }

  save() {
    let postData = {};

    postData["equipment_id"] = this.$route.params["sensor_id"];
    postData["equipment_name"] = this.sensorName.value;
    postData["installation_datetime"] = this.getYYYYMMDD(
      this.installationDatetime.value
    );
    postData["removal_datetime"] = this.getYYYYMMDD(this.removalDatetime.value);
    postData[
      "measure_target_equipment_kind_id"
    ] = this.selectedMeasureTargetEquipmentId;
    postData["lower_limit"] = this.thresholdFrom.value;
    postData["upper_limit"] = this.thresholdTo.value;
    postData["guard_time"] = this.gaurdTime.value;
    postData["snoozing_time"] = this.snoozeTime.value;
    postData["icon_kind"] = parseInt(this.iconKind.value);
    postData["def_time"] = [...this.defTimes];
    postData["time_constant"] = parseInt(this.timeConstant.value);
    postData["disp_flg"] = this.dispFlg;

    postEquipmentsApi(postData).then(() => {
      // SensorsShowPage に戻る
      const path = getRoutePath("SensorsShowPage", {
        store_id: this.$route.params.store_id
      });
      this.$router.push(path);
    });
    return null;
  }

  openDialog() {
    this.isConfirmDialogOpen = true;
  }

  closeConfirm() {
    this.isConfirmDialogOpen = false;
  }

  movePage() {
    this.$router.push(
      getRoutePath("SensorsShowPage", {
        store_id: this.$route.params.store_id
      })
    );
  }

  //バリデーション関数
  isErrorForm(form) {
    return this[form].errors.length > 0;
  }

  getErrorMessages(form) {
    return this[form].errors;
  }

  validateForm() {
    if (this.sensorName.value.length == 0) {
      this.addError("sensorName", "required_input");
    }

    // 2021.09.17 閾値の比較を文字列で行っているため、数値に変換して確認
    const from: number = parseFloat(this.thresholdFrom.value);
    const to: number = parseFloat(this.thresholdTo.value);

    if (
      (this.thresholdFrom.value !== "" && isNaN(from)) ||
      (this.thresholdTo.value !== "" && isNaN(to))
    ) {
      this.addError("thresholdFrom", "character_error");
    } else if (
      (this.thresholdFrom.value === "" && this.thresholdTo.value !== "") ||
      (this.thresholdFrom.value !== "" && this.thresholdTo.value === "") ||
      from < -30 ||
      to > 60 ||
      from > to
    ) {
      this.addError("thresholdFrom", "range_input");
    }
    /*
    if (isNaN(this.thresholdFrom.value) || isNaN(this.thresholdTo.value)) {
      this.addError("thresholdFrom", "character_error");
    } else if (
      (this.thresholdFrom.value === "" && this.thresholdTo.value !== "") ||
      (this.thresholdFrom.value !== "" && this.thresholdTo.value === "") ||
      this.thresholdFrom.value < -30 ||
      this.thresholdTo.value > 60 ||
      this.thresholdFrom.value > this.thresholdTo.value
    ) {
      this.addError("thresholdFrom", "range_input");
    }
    */

    if (this.gaurdTime.value != "") {
      if (isNaN(this.gaurdTime.value)) {
        this.addError("gaurdTime", "character_error");
      } else if (this.gaurdTime.value < 1 || this.gaurdTime.value > 360) {
        this.addError("gaurdTime", "range_error");
      }
    }

    if (this.snoozeTime.value != "") {
      if (isNaN(this.snoozeTime.value)) {
        this.addError("snoozeTime", "character_error");
      } else if (this.snoozeTime.value < 1 || this.snoozeTime.value > 360) {
        this.addError("snoozeTime", "range_error");
      }
    }

    if (this.timeConstant.value) {
      if (isNaN(this.timeConstant.value)) {
        this.addError("timeConstant", "character_error");
      } else if (this.timeConstant.value < 1 || this.timeConstant.value > 200) {
        this.addError("timeConstant", "range_error");
      }
    }
  }

  addError(form, error) {
    let errors = [...this[form].errors];
    errors.push(this.errorMessages[error]);
    this[form].errors = errors;
    this.hasError = true;
  }

  resetError() {
    this.hasError = false;
    const formNames = [
      "sensorName",
      "thresholdFrom",
      "gaurdTime",
      "snoozeTime",
      "timeConstant"
    ];
    formNames.forEach(name => {
      this[name].errors = [];
    });

    this.isDefTimeError = false;
  }

  async setApiData() {
    const equipmentId = this.$route.params["sensor_id"];
    getEquipmentsApi(equipmentId).then((resp: GetEquipmentsResponse) => {
      this.sensorNo = fillZero(resp.location_no, 2);
      this.sensorName.value = resp.equipment_name;
      this.equipmentkindId.value = resp.equipmentkind_id;
      this.iconKind.value = resp.icon_kind;
      this.sensorId.value = resp.equipment_id;
      this.sensorKind.value = resp.equipmentkind_name;
      this.modelName.value = resp.model_name;
      this.serialNo.value = resp.serial_no;
      this.installationDatetime.value = resp.installation_datetime;
      this.removalDatetime.value = resp.removal_datetime;
      this.measureTargetSerialNo.value = resp.measure_target_serial_no;
      this.measureTargetEquipmentKindName.value =
        resp.measure_target_equipment_kind_name;
      this.measureTargetEquipmentKindId.value =
        resp.measure_target_equipment_kind_id;
      this.selectedMeasureTargetEquipmentId =
        resp.measure_target_equipment_kind_id;
      this.thresholdFrom.value = resp.lower_limit;
      this.thresholdTo.value = resp.upper_limit;
      this.gaurdTime.value = resp.guard_time;
      this.snoozeTime.value = resp.snoozing_time;
      this.timeConstant.value =
        resp.time_constant != null ? resp.time_constant : 100;
      this.defTimes = [...resp.def_time];
      this.dispFlg = resp.disp_flg != null ? resp.disp_flg : 0;
    });
    const measureTargetEquipments = await getMeasureTargetEquipments();
    this.measureTargetEquipments = measureTargetEquipments;
  }

  mounted() {
    this.setApiData();
  }

  changeMeasureTargetEquipmentKindId(selected) {
    this.selectedMeasureTargetEquipmentId = selected;
  }

  getYYYYMMDD(date: string): string | null {
    if (!date) {
      return null;
    } else {
      date = date.replace(/\//g, "");
      return date.slice(0, 8);
    }
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }
}
